<script setup lang="ts">
import { computed, PropType } from 'vue';
import { EntityNameSpan } from '@precon-tools-suite-by-shared/shared-names-ui';
import type { ProductDisplayFragment } from './ProductDisplay.generated';

const props = defineProps({
    node: {
        type: Object as PropType<ProductDisplayFragment>,
        default: undefined,
    },
    overview: {
        type: Boolean,
    },
});

const node = computed(() => props.node);
const reference = computed(
    () => node.value?.clientRef ?? '-- geen artikelnummer --'
);
const state = computed(() => (node.value?.isActive ? 'Actief' : 'Inactief'));
</script>

<template>
    <div class="grid">
        <div :class="overview ? 'col-12 ml-1' : 'col'">
            <span class="font-bold">Artikelnummer: </span>
            <span>{{ reference }}</span>
        </div>
        <div :class="overview ? 'col-12 ml-1' : 'col'">
            <span class="font-bold">Productnaam: </span>
            <EntityNameSpan :node="node" size="short" />
        </div>
        <div :class="overview ? 'col-12 ml-1' : 'col'">
            <span class="font-bold">Status: </span>
            {{ state }}
        </div>
    </div>
</template>
